import { render } from "./CheckItem.vue?vue&type=template&id=5d4de354"
import script from "./CheckItem.vue?vue&type=script&lang=js"
export * from "./CheckItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__